import { render, staticRenderFns } from "./Highlight.vue?vue&type=template&id=0f6124ae&scoped=true&"
import script from "./Highlight.vue?vue&type=script&lang=ts&"
export * from "./Highlight.vue?vue&type=script&lang=ts&"
import style0 from "./Highlight.vue?vue&type=style&index=0&id=0f6124ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6124ae",
  null
  
)

export default component.exports